/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { Route, Switch } from "react-router-dom";

import QA from "../../../components/table/qa/QA";
import CreateFirstCTA from "../../../components/table/shared/CreateFirstCTA";
import NewSectionTag from "../../../components/table/shared/NewSectionTag";
import TestDetails from "./TestDetails";
import TestsSchedule from "./TestsSchedule";

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addNewSection?: (...args: any[]) => any;
  canManageSections?: boolean;
  hideSchedule?: boolean;
  isInternal?: boolean;
  moduleWorkspaceID?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recordVersions?: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sectionTags?: any[];
  showAddNewSection?: boolean;
  showCTA?: boolean;
  tableWidth?: string;
};

function QAActiveTests({
  hideSchedule,
  tableWidth,
  recordVersions,
  showAddNewSection,
  moduleWorkspaceID,
  addNewSection,
  showCTA,
  isInternal,
  sectionTags,
  canManageSections,
}: Props) {
  const showTestSchedule = !hideSchedule;

  return (
    <div className="qa-active-container" data-testid="qa-active-tests">
      <Switch>
        <Route exact path="/workspaces/:workspace_id/modules/qa-tests">
          <>
            <div
              style={{ width: tableWidth }}
              className="qa-active-container__wrap"
            >
              <QA
                additionalContent={
                  <>
                    {showAddNewSection && (
                      <NewSectionTag moduleWorkspaceID={moduleWorkspaceID} />
                    )}

                    {isInternal && canManageSections && (
                      <div className="create-new-record add-section">
                        <button
                          onClick={addNewSection}
                          data-testid="add-new-section-button"
                        >
                          Add New Section +
                        </button>
                      </div>
                    )}

                    {showCTA && isInternal && (
                      <CreateFirstCTA subject="QA Test" />
                    )}
                  </>
                }
              />
            </div>
            {showTestSchedule && (
              <TestsSchedule
                recordVersions={recordVersions}
                sectionTags={sectionTags}
              />
            )}
          </>
        </Route>
        <Route path="/workspaces/:workspace_id/modules/qa-tests/:record_version_id">
          <TestDetails isInternal={isInternal} />
        </Route>
        <Route path="/workspaces/:workspace_id/modules/qa-tests-development/:record_version_id">
          <TestDetails isInternal={isInternal} />
        </Route>
      </Switch>
    </div>
  );
}

export default QAActiveTests;
